import PropTypes from 'prop-types';
import { clone, includes, equals, filter, find, path, prop, propEq } from 'ramda';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';
import { createSelector } from 'reselect';
import React, { Component } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { DirectionsBus } from '@material-ui/icons';
import blue from '@material-ui/core/es/colors/blue';
import green from '@material-ui/core/es/colors/green';
import grey from '@material-ui/core/es/colors/grey';
import red from '@material-ui/core/es/colors/red';

import { routeBlockageDetailClose } from '../modules/actions/routeBlockageDetail';


const GreenBus = () => {
  return (
    <DirectionsBus
      style={{ color: green[800], fill: green[800], height: 16, width: 16}}
    />
  );
};

const RedBus = () => {
  return (
    <DirectionsBus
      style={{ color: red[800], fill: red[800], height: 16, width: 16}}
    />
  );
};

const BlueBus = () => {
  return (
    <DirectionsBus
      style={{ color: blue[800], fill: blue[800], height: 16, width: 16}}
    />
  );
};

class RouteBlockageDetail extends Component {
  static propTypes = {
    // State props.
    acceptedInvitedDrivers: PropTypes.array.isRequired,
    companies: PropTypes.array,
    id: PropTypes.string,
    open: PropTypes.bool.isRequired,
    ridesKmZero: PropTypes.array.isRequired,
    ridesKmOne: PropTypes.array.isRequired,
    ridesKmTwo: PropTypes.array.isRequired,
    routeBlockage: PropTypes.shape({
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        'invited-drivers-accepted': PropTypes.number.isRequired,
        'rides-km-zero': PropTypes.number.isRequired,
        'rides-km-one': PropTypes.number.isRequired,
        'rides-km-two': PropTypes.number.isRequired,
        'rides-km-three': PropTypes.number.isRequired,
        'rides-km-four': PropTypes.number.isRequired,
      }).isRequired,
      relationships: PropTypes.shape({
        'stop-from': PropTypes.shape({ data: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired }).isRequired,
        'stop-to': PropTypes.shape({ data: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired }).isRequired,
      }).isRequired,
    }),
    stopFrom: PropTypes.shape({}),
    stopTo: PropTypes.shape({}),

    // Dispatch props.
    readEndpoint: PropTypes.func.isRequired,
    routeBlockageDetailClose: PropTypes.func.isRequired,
  };

  componentWillReceiveProps(nextProps) {
    const { readEndpoint } = nextProps;

    if (nextProps.id && nextProps.id !== this.props.id) {
      readEndpoint(`route-blockage/${nextProps.id}`);
      readEndpoint(`reserved-vehicle?filter[routeblockage__exact]=${nextProps.id}`);
      readEndpoint(`invited-driver?filter[routeblockage__exact]=${nextProps.id}`);
      readEndpoint(`ride?filter[routeblockage__exact]=${nextProps.id}`);
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    /**
     * Render when all required components have loaded.
     */
    if ((!this.props.routeBlockage ||
         !this.props.stopFrom ||
         !this.props.stopTo) &&
        (nextProps.routeBlockage &&
         nextProps.stopFrom &&
         nextProps.stopTo)) {
      return true;
    }

    /**
     * Render as soon as one of the required components has unloaded.
     */
    if ((this.props.routeBlockage &&
         this.props.stopFrom &&
         this.props.stopTo) &&
        (!nextProps.routeBlockage ||
         !nextProps.stopFrom ||
         !nextProps.stopTo)) {
      return true;
    }

    /**
     * Render when some of the route blockage-related data has changed.
     */
    if ((this.props.routeBlockage && nextProps.routeBlockage) &&
        (this.props.stopFrom && nextProps.stopFrom) &&
        (this.props.stopTo && nextProps.stopTo) &&
        (!equals(this.props.companies, nextProps.companies) ||
         !equals(this.props.acceptedInvitedDrivers, nextProps.acceptedInvitedDrivers) ||
         !equals(this.props.ridesKmZero, nextProps.ridesKmZero) ||
         !equals(this.props.ridesKmOne, nextProps.ridesKmOne) ||
         !equals(this.props.ridesKmTwo, nextProps.ridesKmTwo))) {
      return true;
    }


    /**
     * Don't render when the component is in a state between loaded and
     * unloaded.
     */
    return false;
  };

  handleClose = () => {
    const { routeBlockageDetailClose } = this.props;

    routeBlockageDetailClose();
  };

  render() {
    const {
      companies, routeBlockage, stopFrom, stopTo,
      acceptedInvitedDrivers,
      ridesKmZero, ridesKmOne, ridesKmTwo,
    } = this.props;

    /**
     * Render nothing if not all required components have loaded.
     */
    if (!routeBlockage || !stopFrom || !stopTo) {
      return null;
    }

    const vehicleCount = path(['attributes', 'vehicles-required'], routeBlockage) || 0;

    // Rides with two distance counts are shuttling.
    const greenCount = routeBlockage.attributes['rides-km-two'];

    // Rides with one distance count are on their way to the route blockage.
    const redCount = routeBlockage.attributes['rides-km-one'];

    // Invited drivers who have accepted, or rides with no distance counts,
    // have reserved slots.
    const blueCount = routeBlockage.attributes['invited-drivers-accepted'] + routeBlockage.attributes['rides-km-zero'];

    let icons = [];

    for (let i = 0; i < greenCount; i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: green[800], fill: green[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = greenCount; i < (greenCount + redCount); i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: red[800], fill: red[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = (greenCount + redCount); i < (greenCount + redCount + blueCount); i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: blue[800], fill: blue[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = (greenCount + redCount + blueCount); i < vehicleCount; i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: grey[300], fill: grey[300], height: 16, width: 16 }}
        />
      ));
    }

    return (
      <Dialog open={true} onClose={this.handleClose} scroll="body">
        <DialogTitle>{`Stremming \`${stopFrom.attributes.name} naar ${stopTo.attributes.name}\``}</DialogTitle>
        <div style={{ marginTop: 24 }}>{icons}</div>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Bedrijf</TableCell>
              <TableCell>
                <GreenBus />
                <div>Pendelende bussen<br />&nbsp;</div>
              </TableCell>
              <TableCell>
                <RedBus />
                <div>Bussen van stalling<br />naar eerste station</div>
              </TableCell>
              <TableCell>
                <BlueBus />
                <div>Gereserveerde slots<br />&nbsp;</div>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {companies.map(c => {
              const companyName = path(['attributes', 'name'], c) || 'Onbekend';
              const companyGreenCount = filter(r => (Number(r.attributes['company-id']) === Number(c.id)), ridesKmTwo).length;
              const companyRedCount = filter(r => (Number(r.attributes['company-id']) === Number(c.id)), ridesKmOne).length;
              const companyBlueCount = filter(r => (Number(r.attributes['company-id']) === Number(c.id)), ridesKmZero).length +
                filter(id => (Number(id.attributes['company-id']) === Number(c.id)), acceptedInvitedDrivers).length;

              return (
                <TableRow key={'row-' + c.id}>
                  <TableCell>{companyName}</TableCell>
                  <TableCell>{companyGreenCount}</TableCell>
                  <TableCell>{companyRedCount}</TableCell>
                  <TableCell>{companyBlueCount}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Dialog>
    );
  };
}


/**
 * Redux base selectors.
 */
const _selectRouteBlockage = state => {
  const rbid = path(['routeBlockageDetail', 'id'], state);

  if (rbid === null) return undefined;

  const rbs = path(['api', 'route-blockage', 'data'], state) || [];

  return find(propEq('id', rbid))(rbs);
};
const _selectInvitedDrivers = state => path(['api', 'invited-driver', 'data'], state) || [];
const _selectRides = state => path(['api', 'ride', 'data'], state) || [];
const _selectStops = state => path(['api', 'stop', 'data'], state) || [];
const _selectCompanies = state => path(['api', 'company', 'data'], state) || [];

/**
 * Redux memoizing selectors.
 */
const getStopFrom = createSelector([_selectRouteBlockage, _selectStops], (rb, ss) => {
  if (!rb) return undefined;

  const sfid = path(['relationships', 'stop-from', 'data', 'id'], rb);

  if (sfid === undefined) return undefined;

  return find(propEq('id', sfid))(ss);
});

const getStopTo = createSelector([_selectRouteBlockage, _selectStops], (rb, ss) => {
  if (!rb) return undefined;

  const stid = path(['relationships', 'stop-to', 'data', 'id'], rb);

  if (stid === undefined) return undefined;

  return find(propEq('id', stid))(ss);
});

const getAcceptedInvitedDrivers = createSelector([_selectRouteBlockage, _selectInvitedDrivers], (rb, ids) => {
  if (!rb) return [];

  const idids = (path(['relationships', 'invited-drivers', 'data'], rb) || []).map(id => Number(id.id));

  return filter(id => {
    return includes(Number(id.id), idids) && path(['attributes', 'accepted'], id) === true;
  })(ids);
});

const getRidesKmZero = createSelector([_selectRouteBlockage, _selectRides], (rb, rs) => {
  if (!rb) return [];

  const rids = (path(['relationships', 'rides', 'data'], rb) || []).map(r => Number(r.id));

  return filter(r => {
    return includes(Number(r.id), rids) &&
      typeof path(['attributes', 'distance-depot-start'], r) !== "number" &&
      typeof path(['attributes', 'distance-shuttle-start'], r) !== "number" &&
      typeof path(['attributes', 'distance-shuttle-end'], r) !== "number" &&
      typeof path(['attributes', 'distance-depot-end'], r) !== "number";
  })(rs);
});

const getRidesKmOne = createSelector([_selectRouteBlockage, _selectRides], (rb, rs) => {
  if (!rb) return [];

  const rids = (path(['relationships', 'rides', 'data'], rb) || []).map(r => Number(r.id));

  return filter(r => {
    return includes(Number(r.id), rids) &&
      typeof path(['attributes', 'distance-depot-start'], r) === "number" &&
      typeof path(['attributes', 'distance-shuttle-start'], r) !== "number" &&
      typeof path(['attributes', 'distance-shuttle-end'], r) !== "number" &&
      typeof path(['attributes', 'distance-depot-end'], r) !== "number";
  })(rs);
});

const getRidesKmTwo = createSelector([_selectRouteBlockage, _selectRides], (rb, rs) => {
  if (!rb) return [];

  const rids = (path(['relationships', 'rides', 'data'], rb) || []).map(r => Number(r.id));

  return filter(r => {
    return includes(Number(r.id), rids) &&
      typeof path(['attributes', 'distance-depot-start'], r) === "number" &&
      typeof path(['attributes', 'distance-shuttle-start'], r) === "number" &&
      typeof path(['attributes', 'distance-shuttle-end'], r) !== "number" &&
      typeof path(['attributes', 'distance-depot-end'], r) !== "number";
  })(rs);
});

const getInvitedCompanies = createSelector([_selectRouteBlockage, _selectCompanies], (rb, cs) => {
  if (!rb) return [];

  const pcids = (path(['relationships', 'invited-preferred-companies', 'data'], rb) || []).map(c => c.id);
  const npcids = (path(['relationships', 'invited-companies', 'data'], rb) || []).map(c => c.id);
  let cids = clone(pcids);

  if (path(['attributes', 'invite-non-preferred-companies'], rb)) {
    cids = cids.concat(npcids);
  }

  const isInvitedCompany = a => {
    return includes(prop('id', a), cids);
  };

  return filter(isInvitedCompany)(cs);
});

const mapStateToProps = (state) => ({
  acceptedInvitedDrivers: getAcceptedInvitedDrivers(state),
  companies: getInvitedCompanies(state),
  id: path(['routeBlockageDetail', 'id'], state),
  open: path(['routeBlockageDetail', 'id'], state) !== null,
  ridesKmZero: getRidesKmZero(state),
  ridesKmOne: getRidesKmOne(state),
  ridesKmTwo: getRidesKmTwo(state),
  routeBlockage: _selectRouteBlockage(state),
  stopFrom: getStopFrom(state),
  stopTo: getStopTo(state),
});

const mapDispatchToProps = {
  readEndpoint,
  routeBlockageDetailClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteBlockageDetail);
